import React from 'react';

import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import Datetime from 'components/Shared/Datetime';

import { ApiPieceAddAction, ApiPieceGestionLigne } from 'types/apiReturns';

type Props = {
    piece: ApiPieceAddAction | null;
    lignes: ApiPieceGestionLigne[];
};

// Panneau d'aperçu d'une pièce validée : entête (numéro, commande d'origine, client) + lignes.
export default function PieceApercu({ piece, lignes }: Props) {

    if (piece === null) {
        return (
            <Typography variant="body2" color="textSecondary">
                Saisissez une pièce pour afficher son contenu.
            </Typography>
        );
    }

    return (
        <div>
            <Typography variant="subtitle2">
                Pièce {piece.numeroPiece}
            </Typography>

            {(piece.commandeOrigine || piece.codeClient || piece.dateCreation) && (
                <Typography variant="body2" color="textSecondary" gutterBottom component="div">
                    {piece.commandeOrigine ? `Commande ${piece.commandeOrigine}` : null}
                    {piece.commandeOrigine && piece.codeClient ? ' — ' : null}
                    {piece.codeClient ? `Client ${piece.codeClient}` : null}
                    {(piece.commandeOrigine || piece.codeClient) && piece.dateCreation ? ' — ' : null}
                    {piece.dateCreation ? <>du <Datetime datetime={piece.dateCreation} /></> : null}
                </Typography>
            )}

            {lignes.length === 0 ? (
                <Typography variant="body2" color="textSecondary">
                    Aucune ligne à afficher.
                </Typography>
            ) : (
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Article</TableCell>
                            <TableCell>Désignation</TableCell>
                            <TableCell align="right">Quantité</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {lignes.map(ligne => (
                            <TableRow key={`${ligne.numeroLigne}-${ligne.codeArticle}`}>
                                <TableCell>{ligne.codeArticle}</TableCell>
                                <TableCell>{ligne.designationArticle}</TableCell>
                                <TableCell align="right">{ligne.quantite}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            )}
        </div>
    );
}
